import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_TERMS_PRIVACY_DATA = 'GET_TERMS_PRIVACY_DATA';
export const GET_TERMS_PRIVACY_DATA_SUCCESS = 'GET_TERMS_PRIVACY_DATA_SUCCESS';
export const GET_TERMS_PRIVACY_DATA_FAILURE = 'GET_TERMS_PRIVACY_DATA_FAILURE';

// Action Creators
export const getTermsPrivacy = () => ({
  type: GET_TERMS_PRIVACY_DATA,
});

export const getTermsPrivacySuccess = (users) => ({
  type: GET_TERMS_PRIVACY_DATA_SUCCESS,
  payload: users,
});

export const getTermsPrivacyFailure = (error) => ({
  type: GET_TERMS_PRIVACY_DATA_FAILURE,
  payload: error,
});

// Thunk Function
export const getTermsPrivacyDataCallApi = (external) => {
  return async (dispatch) => {
    dispatch(getTermsPrivacy());
    try {
      const response = await getMethodWithToken(
        url.getTermsConditionPrivacyPolicy + '?slug=' + external.slug
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getTermsPrivacySuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getTermsPrivacyFailure(error?.message));
    }
  };
};
